import { AxiosResponse } from "axios";
import { deleteAsync, getAsync, postAsync, putAsync } from "./client";
import { Flower } from "../@type/flowerType";

class FlowerPackageService {
  
  get = async (id: number): Promise<AxiosResponse> => {
    try {
      let url = `flower-packages/${id}`;
      const response = await getAsync(url);
      return response;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  getById = async (id: number): Promise<AxiosResponse> => {
    return await getAsync(`flower-packages/${id}`);
  };

  post = async (data: Flower): Promise<AxiosResponse> => {
    return await postAsync("flowers", data);
  };
update = async (packageId: number, oldFlowerId: number, newFlowerId: number): Promise<AxiosResponse> => {
  return await putAsync(
    `flower-packages/${packageId}/flowers/${oldFlowerId}/replace/${newFlowerId}`, 
    null // hoặc undefined
  );
}

  delete = async (_id: any): Promise<AxiosResponse> => {
    return await deleteAsync(`/product/${_id}`);
  };
}

const flowerPackageService = new FlowerPackageService();
export default flowerPackageService;
